import {gql} from '@apollo/client'

export const CHECK_NEED_EMPLOYEE_UPDATE = gql`
  query checkNeedEmployeeUpdate($employeeId: ID!) {
    client {
      id
      employee(employeeId: $employeeId) {
        id
        needEmployeeUpdate
      }
    }
  }
`

export interface CheckNeedEmployeeQueryVariables {
  employeeId: string
}

export interface CheckNeedEmployeeQueryResult {
  client: {
    id: string
    employee: {
      id: string
      needEmployeeUpdate: boolean
    }
  }
}

export const EMPLOYEES = gql`
  query employees($limit: Int, $page: Int, $search: EmployeeSearchInput) {
    client {
      id
      employees(limit: $limit, page: $page, search: $search) {
        totalCount
        list {
          id
          staffCode
          displayFirstName
          displayLastName
          email
          personnelHistory {
            officeName
            employmentTypeName
            group0Name
            group1Name
            group2Name
          }
          currentOffice {
            id
            name
          }
        }
      }
    }
  }
`

export interface EmployeesQueryVariables {
  page?: number | null
  limit?: number | null
  search?: EmployeeSearchInput | null
}

export type SortOrder = 'asc' | 'desc'

export type SortColumn =
  | 'staff_code'
  | 'full_name_kana'
  | 'office'
  | 'employment_type'
  | 'group'
  | 'position'
  | 'occupation'
  | 'joined_at'

interface EmployeeSearchInput {
  employmentStatus?: string | null
  q?: string | null
  sortOrder?: SortOrder | null
  sortColumn?: SortColumn | null
  officeIds?: string[] | null
  groupIds?: string[] | null
  positionIds?: string[] | null
  occupationIds?: string[] | null
  employmentTypeIds?: string[] | null
  joinedHealthInsurance?: string | null
  joinedWelfarePensionInsurance?: string | null
  joinedEmploymentInsurance?: string | null
  ageFrom?: number | null
  ageTo?: number | null
  ageBaseDate?: string | null
  joinedAtStart?: string | null
  joinedAtEnd?: string | null
  formerName?: string | null
  birthdayStart?: string | null
  birthdayEnd?: string | null
  genders?: (string | null)[] | null
  countries?: string[] | null
  prefectureIds?: string[] | null
  nationalTypes?: (string | null)[] | null
  nationIds?: string[] | null
  visaTypeIds?: string[] | null
  retiredAtStart?: string | null
  retiredAtEnd?: string | null
  retireTypes?: (string | null)[] | null
  hasDependents?: boolean[] | null
  maritalStatuses?: (string | null)[] | null
  remunerationTypes?: (string | null)[] | null
  handicapTypes?: (string | null)[] | null
  widowTypes?: (string | null)[] | null
  workingStudentTypes?: (string | null)[] | null
  tagIds?: string[] | null
  skills?: string[] | null
  qualifications?: string[] | null
  languageIds?: string[] | null
  languageLevelIds?: string[] | null
  languagesQualificationName?: string | null
  languagesScoreFrom?: number | null
  languagesScoreTo?: number | null
  projects?: string[] | null
  applicableProcedure?: string | null
}

export interface Employees {
  client: {
    employees: {
      totalCount: number
      list: Employee[]
    }
  }
}

export interface Employee {
  id: string
  staffCode?: string
  displayFirstName: string
  displayLastName: string
  email?: string
  personnelHistory?: {
    officeName?: string
    employmentTypeName?: string
    group0Name?: string
    group1Name?: string
    group2Name?: string
  }
  currentOffice?: {
    name: string
  }
}
